<template>
  <modal :is-open="sellSuccessDialogIsOpen" :closeable="false">
    <div>
      {{ translation.itemList.sellSuccess }}!
    </div>
    <template #footer>
      <button type="button" class="btn btn-secondary" @click="$emit('item-used'); sellSuccessDialogIsOpen = false;">
        {{ translation.general.okay }}
      </button>
    </template>
  </modal>

  <modal :is-open="itemsReceived.length > 0" :closeable="false">
    <div style="display: flex;justify-content: space-between;width:80%;margin:auto;">


      <div v-for="item in itemsReceived" :key="item" style="position:relative;">

        <ItemEntryButton :id="1" :name="item.name" :category="item.category" :sprite_name="item.sprite_name" :amount="1"/>
      </div>
    </div>

    <template #footer>
      <button type="button" class="btn btn-secondary" @click="$emit('item-used'); itemsReceived = [];">
        {{ translation.general.okay }}
      </button>
    </template>
  </modal>

  <modal :is-open="useSuccessDialogIsOpen" :closeable="false">
    <div>
      {{ translation.itemList.useItemSuccess }}!
    </div>
    <template #footer>
      <button type="button" class="btn btn-secondary" @click="$emit('item-used'); useSuccessDialogIsOpen = false;">
        {{ translation.general.okay }}
      </button>
    </template>
  </modal>

  <modal :is-open="sellConfirmationDialogIsOpen" :closeable="false">

          <span
              v-html="
        translation.shop.sellConfirmationMessage(
          currentItem.name,
          amount,
          totalCosts
        )
      "
          ></span>

    <template #footer>
      <button type="button" class="btn btn-primary" @click="confirmSell(currentItem.id, amount);">
        {{ translation.general.okay }}
      </button>
      <button type="button" class="btn btn-secondary" @click="sellConfirmationDialogIsOpen = false">
        {{ translation.general.cancel }}
      </button>
    </template>
  </modal>

  <modal :is-open="sellDialogIsOpen && !sellSuccessDialogIsOpen && !sellConfirmationDialogIsOpen" :closeable="false">
    <div>
      <span v-html="translation.itemList.sellConfirmMessage(currentItem.name, currentItem.sell_price)"></span>({{
        currentItem.amount
      }})
    </div>

    <input
        type="number"
        v-model="amount"
        @keyup="calcTotalCosts(amount)"
        @change="calcTotalCosts(amount)"
        min="1"
        max="100"
        style="width: 40%"
        @input="limit_buy_amount()"
    />

    <div style="margin-top: 8px;">
      <button @click="calcTotalCosts(5)"
              style="margin: 3px;border-color: #ff444b;width: 30px;border-radius: 4px;">5
      </button>
      <button @click="calcTotalCosts(10)"
              style="margin: 3px;border-color: #ff444b;width: 30px;border-radius: 4px;">10
      </button>
      <button @click="calcTotalCosts(20)"
              style="margin: 3px;border-color: #ff444b;width: 30px;border-radius: 4px;">20
      </button>
      <button @click="calcTotalCosts(currentItem.amount)"
              style="margin: 3px;border-color: #ff444b;width: 50px;border-radius: 4px;">Max
      </button>
    </div>

    <template #footer>
      <button type="button" class="btn btn-warning pokeinfo-footer__sell"
              @click="sellConfirmationDialogIsOpen=true;">
        {{ translation.pokemonList.sell(totalCosts) }}
      </button>
      <button type="button" class="btn btn-secondary" @click="sellDialogIsOpen = false">
        {{ translation.general.cancel }}
      </button>
    </template>
  </modal>

  <modal
      :is-open="isOpen && !useSuccessDialogIsOpen && !sellDialogIsOpen && !sellSuccessDialogIsOpen && !isLoading && itemsReceived.length === 0"
      :closeable="false">

    <div>
      <h4>{{ currentItem.name }}</h4>

      <div>
        {{ currentItem.description }}
      </div>

      <div v-if="currentItem.type === 2">
        <br>
        <div>
          <div style="font-weight: bold;text-decoration: underline;">Catch rate</div>
          {{ currentItem.catchRate }}
        </div>
      </div>
    </div>

    <template #footer>
      <button v-if="currentItem.usable" type="button" class="btn btn-warning pokeinfo-footer__sell"
              @click="useItem(currentItem.id)">
        {{ translation.itemList.useItem }}
      </button>

      <button v-if="currentItem.sell_price > 0" type="button" class="btn btn-warning pokeinfo-footer__sell"
              @click="calcTotalCosts(1);sellDialogIsOpen = true">
        {{ translation.pokemonList.sell(currentItem.sell_price) }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('update:is-open', false)">
        {{ translation.general.cancel }}
      </button>
    </template>
  </modal>


</template>

<script>
import Modal from "@/components/Modal/Modal";
import {translation} from "@/utils/translations";
import {backendUri} from "@/utils/settings";
import axios from "axios";
import {ref} from "@vue/reactivity";
import {showModalMsg} from "@/components/Modal/modalUtils";
import {startLoadingProcess, stopLoadingProcess} from "@/components/LoadingOverlay/loadingOverlayControl";
import {handleUnknownError} from "@/utils/utilities";
import ItemEntryButton from "../../components/ItemEntryButton/ItemEntryButton.vue";


export default {
  name: "InfoPanel",
  components: {ItemEntryButton, Modal},
  emits: ['item-used'],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    currentItem: {
      type: Object
    }
  },
  methods: {
    limit_buy_amount: function () {
      if (!Number.isInteger(this.amount)) {
        this.amount = 1;
      }

      if (this.amount <= 0) {
        this.amount = 1;
      } else if (this.amount > 100) {
        this.amount = 100;
      }
    },
  },
  setup(props) {
    const sellSuccessDialogIsOpen = ref(false);
    const useSuccessDialogIsOpen = ref(false);
    const sellDialogIsOpen = ref(false);
    const sellConfirmationDialogIsOpen = ref(false);
    const itemsReceived = ref([]);
    const amount = ref(0);

    const totalCosts = ref(0);
    const calcTotalCosts = async (_amount) => {
      if (_amount > props.currentItem.amount) {
        amount.value = props.currentItem.amount
      } else {
        amount.value = _amount
      }
      totalCosts.value = props.currentItem.sell_price * amount.value;

      sellDialogIsOpen.value = true;
      if (props.currentItem.amount === 1) {
        sellConfirmationDialogIsOpen.value = true;
      }
    };

    const confirmSell = async (item_id, amount) => {
      startLoadingProcess();
      await axios.post(backendUri + "api/game/ext/trainer/sell-item/" + item_id + "/", {"amount": amount})
          .then((resp) => {
            sellSuccessDialogIsOpen.value = true;
            sellDialogIsOpen.value = false;
            sellConfirmationDialogIsOpen.value = false;
            console.log(resp);
          })
          .catch(error => {

            if (error.response.data.error === 1) {
              showModalMsg(translation.itemList.itemNotExists);
            } else if (error.response.data.error === 50) {
              showModalMsg(translation.shop.itemAmountLessThenZero);
            } else {
              handleUnknownError(error);
            }

          })
      stopLoadingProcess();
    }

    const useItem = async (item_id) => {
      startLoadingProcess();
      await axios.post(backendUri + "api/game/ext/trainer/use-item/" + item_id + "/")
          .then((resp) => {
            if (resp.data.itemsReceived.length > 0) {
              itemsReceived.value = resp.data.itemsReceived;
            } else {
              useSuccessDialogIsOpen.value = true;
            }

            console.log(resp);
          })
          .catch(error => {
            if (error.response.data.error === 1) {
              showModalMsg(translation.itemList.itemNotExists);
            } else if (error.response.data.error === 2) {
              showModalMsg(translation.itemList.itemAlreadyActive);
            } else if (error.response.data.error === 10) {
              showModalMsg(translation.itemList.itemTeamListFull);
            } else if (error.response.data.error === 20) {
              showModalMsg(translation.itemList.wonderPassNoCooldown);
            } else if (error.response.data.error === 21) {
              showModalMsg(translation.itemList.pokedailyNoCooldown);
            } else {
              handleUnknownError(error);
            }
          })
      stopLoadingProcess();
    }

    return {
      translation,
      backendUri,
      useSuccessDialogIsOpen,
      sellSuccessDialogIsOpen,
      useItem,
      confirmSell,
      sellDialogIsOpen,
      calcTotalCosts,
      totalCosts,
      sellConfirmationDialogIsOpen,
      amount,
      itemsReceived
    }
  }
}
</script>

<style lang="scss" scoped>
.pokeinfo-footer {
  &__sell {
    background: linear-gradient(to right, rgb(255, 189, 42), rgb(255, 202, 53));
  }

  &__caught-using-ball {
    max-height: 48px;
  }

  &__caught-at {
    color: #b5b5b5;
  }
}
</style>